import { SHOW_LOADING, HIDE_LOADING } from '../actions/loadingActions';

export function loading(state = { show: false, request: 0 }, action) {
  switch (action.type) {
    case SHOW_LOADING:
    case '_REQUEST':
      return {
        ...state,
        request: state.request + 1,
        show: true,
      };
    case HIDE_LOADING:
    case '_FAILURE':
    case '_SUCCESS':
      return {
        ...state,
        request: state.request - 1,
        show: state.request - 1 > 0,
      };
    default:
      return state;
  }
}
